angular.module('PatientApp').factory('SsoService', function($log, $resource, $q, endpoints){
    var SSO = $resource(null, null, {
        prep: {
            method: 'POST',
            url: endpoints.sso.prep.url
        },
        token: {
            method: 'POST',
            url: endpoints.sso.token.url
        }
    });

    return {
        getToken: function(context) {
            return SSO.prep(context).$promise
                .then(function(resp){
                    if(resp && resp.hasData()){
                        return resp.getData();
                    }
                    return $q.reject(resp);
                });
        },

        postToken: function(token) {
            return SSO.token({token: token}).$promise
                .then(function(resp){
                    if(resp && resp.hasData()){
                        return resp.getData();
                    }
                    return $q.reject(resp);
                });
        }
    };

});